export var SwapLiquidationTrancheStatusEnum;
(function (SwapLiquidationTrancheStatusEnum) {
    SwapLiquidationTrancheStatusEnum["PENDING"] = "pending";
    SwapLiquidationTrancheStatusEnum["PROCESSING"] = "processing";
    SwapLiquidationTrancheStatusEnum["DEPOSIT_REBALANCING_PENDING"] = "deposit_rebalancing_pending";
    SwapLiquidationTrancheStatusEnum["DEPOSIT_REBALANCING_CONFIRMED"] = "deposit_rebalancing_confirmed";
    SwapLiquidationTrancheStatusEnum["DEPOSIT_REBALANCING_FAILED"] = "deposit_rebalancing_failed";
    SwapLiquidationTrancheStatusEnum["LIQUIDATION_PENDING"] = "liquidation_pending";
    SwapLiquidationTrancheStatusEnum["LIQUIDATION_CONFIRMED"] = "liquidation_confirmed";
    SwapLiquidationTrancheStatusEnum["LIQUIDATION_FAILED"] = "liquidation_failed";
    SwapLiquidationTrancheStatusEnum["WITHDRAW_REBALANCING_PENDING"] = "withdraw_rebalancing_pending";
    SwapLiquidationTrancheStatusEnum["WITHDRAW_REBALANCING_CONFIRMED"] = "withdraw_rebalancing_confirmed";
    SwapLiquidationTrancheStatusEnum["WITHDRAW_REBALANCING_FAILED"] = "withdraw_rebalancing_failed";
    SwapLiquidationTrancheStatusEnum["COMPLETED"] = "completed";
    SwapLiquidationTrancheStatusEnum["FAILED"] = "failed";
    SwapLiquidationTrancheStatusEnum["PAUSED"] = "paused";
    SwapLiquidationTrancheStatusEnum["PENDING_MANUAL_RETRY"] = "pending_manual_retry";
})(SwapLiquidationTrancheStatusEnum || (SwapLiquidationTrancheStatusEnum = {}));
//# sourceMappingURL=swap-liquidation-tranche-status.enum.js.map